import { render, staticRenderFns } from "./ProjectHistory.vue?vue&type=template&id=616226aa&scoped=true&"
import script from "./ProjectHistory.vue?vue&type=script&lang=js&"
export * from "./ProjectHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHistory.vue?vue&type=style&index=0&id=616226aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616226aa",
  null
  
)

export default component.exports